import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  achievements: [],
  partners: [],
  team: [],
  loading: false,
  error: null,
};

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setAchievements: (state, action) => {
      state.achievements = action.payload;
    },
    setPartners: (state, action) => {
      state.partners = action.payload;
    },
    setTeam: (state, action) => {
      state.team = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setAchievements, setPartners, setTeam, setLoading, setError } = homeSlice.actions;
export default homeSlice.reducer; 